import { render, staticRenderFns } from "./defaultSelect.vue?vue&type=template&id=1dab5224&scoped=true"
import script from "./defaultSelect.vue?vue&type=script&lang=js"
export * from "./defaultSelect.vue?vue&type=script&lang=js"
import style0 from "./defaultSelect.vue?vue&type=style&index=0&id=1dab5224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab5224",
  null
  
)

export default component.exports